/* ==========================================================
   Embroidery Monkey – Mega menu for "Categories" (desktop)
   - Loads sections/em-mega-menu.liquid only when needed
   - Opens on hover (or keyboard focus) of the Categories link
   - Clicking "Categories" still goes to the categories page
   ========================================================== */
(function () {
  if (window.EMMegaMenu) return;
  window.EMMegaMenu = true;

  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function findTrigger() {
    return (
      document.getElementById('HeaderMenu-categories') ||
      document.querySelector('.header__inline-menu a[href$="/collections"]')
    );
  }

  function start() {
    var trigger = findTrigger();
    if (!trigger) return;
    var triggerItem = trigger.closest('li') || trigger;

    // Base styles for the floating panel (the rest comes with the section)
    var style = document.createElement('style');
    style.textContent =
      '.em-mega{position:absolute;left:0;right:0;margin:6px auto 0;width:min(1440px,calc(100% - 48px));z-index:1000;background:#fff;border:1px solid #e3d3c3;border-top:4px solid #c9550d;border-radius:4px 4px 16px 16px;overflow:hidden;box-shadow:0 24px 60px rgba(40,20,5,.22),0 2px 8px rgba(0,0,0,.06);opacity:0;visibility:hidden;transform:translateY(-6px);transition:opacity .16s ease,transform .16s ease,visibility 0s linear .16s;}' +
      '.em-mega.is-open{opacity:1;visibility:visible;transform:none;transition:opacity .16s ease,transform .16s ease;}' +
      '.em-mega__loading{padding:60px;text-align:center;color:#8a3a0a;font-weight:700;}' +
      '.em-mega-trigger{position:relative;}' +
      '.em-mega-trigger > span:after{content:"";display:inline-block;width:6px;height:6px;margin-left:8px;border-right:2px solid currentColor;border-bottom:2px solid currentColor;transform:translateY(-3px) rotate(45deg);transition:transform .15s;}' +
      '.em-mega-trigger[aria-expanded="true"] > span:after{transform:translateY(0) rotate(-135deg);}';
    document.head.appendChild(style);

    trigger.classList.add('em-mega-trigger');
    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-expanded', 'false');

    var panel = document.createElement('div');
    panel.className = 'em-mega';
    panel.setAttribute('aria-label', 'Categories');
    panel.innerHTML = '<div class="em-mega__loading">Loading categories…</div>';
    document.body.appendChild(panel);

    var loaded = false;
    var loading = null;
    var openTimer = null;
    var closeTimer = null;

    function load() {
      if (loading) return loading;
      loading = fetch(ROOT + '?section_id=em-mega-menu')
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('.shopify-section') || doc.body;
          panel.innerHTML = section.innerHTML;
          loaded = true;
          setup();
        })
        .catch(function () {
          loading = null;
          panel.innerHTML = '<div class="em-mega__loading"><a href="' + ROOT + 'collections">Browse all categories →</a></div>';
        });
      return loading;
    }

    function position() {
      var header = document.querySelector('.section-header') || document.querySelector('header');
      if (!header) return;
      var rect = header.getBoundingClientRect();
      panel.style.top = rect.bottom + window.scrollY + 'px';
    }

    function open() {
      if (!DESKTOP.matches) return;
      clearTimeout(closeTimer);
      position();
      panel.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      if (!loaded) load();
    }

    function close() {
      panel.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    function scheduleOpen() {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(open, 120);
    }

    function scheduleClose() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(close, 250);
    }

    // Hover
    triggerItem.addEventListener('mouseenter', scheduleOpen);
    triggerItem.addEventListener('mouseleave', scheduleClose);
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', scheduleClose);

    // Keyboard
    trigger.addEventListener('focus', open);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) {
        close();
        trigger.focus();
      }
    });

    // Click outside closes
    document.addEventListener('click', function (e) {
      if (!panel.classList.contains('is-open')) return;
      if (panel.contains(e.target) || triggerItem.contains(e.target)) return;
      close();
    });

    // Keep it in place if the window changes
    window.addEventListener('resize', function () {
      if (!DESKTOP.matches) close();
      else if (panel.classList.contains('is-open')) position();
    });

    // Warm up in the background once the page is idle, so the first hover is instant
    var warm = function () { if (DESKTOP.matches) load(); };
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 4000 });
    else setTimeout(warm, 2500);

    // Keep only categories that appear in the left sidebar (if the sidebar is on the page)
    function matchSidebar() {
      var sideLinks = document.querySelectorAll('aside.sidebar a[href*="/collections/"]');
      if (!sideLinks.length) return;
      var allowed = {};
      sideLinks.forEach(function (a) {
        allowed[a.pathname.replace(/\/$/, '').toLowerCase()] = true;
      });
      function keep(a) {
        return !!allowed[a.pathname.replace(/\/$/, '').toLowerCase()];
      }
      // A–Z list
      panel.querySelectorAll('[data-em-az-item]').forEach(function (a) {
        if (!keep(a)) a.remove();
      });
      // remove letter headings left with no categories under them
      panel.querySelectorAll('[data-em-letter-head]').forEach(function (h) {
        var next = h.nextElementSibling;
        if (!next || next.hasAttribute('data-em-letter-head')) h.remove();
      });
      // seasonal category list
      panel.querySelectorAll('[data-em-pane="season"] .em-mega__links a').forEach(function (a) {
        if (!keep(a)) {
          var li = a.closest('li');
          (li || a).remove();
        }
      });
    }

    function setup() {
      matchSidebar();
      var closeBtn = panel.querySelector('[data-em-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { close(); });

      // Tabs: hover or click switches the right side
      var tabs = panel.querySelectorAll('[data-em-tab]');
      var panes = panel.querySelectorAll('[data-em-pane]');
      function activate(name) {
        tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-em-tab') === name); });
        panes.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-em-pane') === name); });
      }
      var hoverTimer = null;
      tabs.forEach(function (t) {
        t.addEventListener('mouseenter', function () {
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(function () { activate(t.getAttribute('data-em-tab')); }, 90);
        });
        t.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); });
        t.addEventListener('click', function () { activate(t.getAttribute('data-em-tab')); });
      });

      // A–Z letter buttons
      var az = panel.querySelector('[data-em-az]');
      var letters = panel.querySelector('[data-em-letters]');
      var scroller = panel.querySelector('.em-mega__panes');
      var heads = az ? az.querySelectorAll('[data-em-letter-head]') : [];
      if (letters) {
        heads.forEach(function (h) {
          var b = document.createElement('button');
          b.type = 'button';
          b.textContent = h.getAttribute('data-em-letter-head');
          b.addEventListener('click', function () {
            if (!scroller) return;
            var top = h.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - 10;
            scroller.scrollTo({ top: top, behavior: 'smooth' });
          });
          letters.appendChild(b);
        });
      }

      // Live filter
      var filter = panel.querySelector('[data-em-filter]');
      var nomatch = panel.querySelector('[data-em-nomatch]');
      if (filter && az) {
        filter.addEventListener('input', function () {
          var q = filter.value.trim().toLowerCase();
          var any = false;
          var currentHead = null;
          var headHasHit = false;
          Array.prototype.forEach.call(az.children, function (el) {
            if (el.hasAttribute('data-em-letter-head')) {
              if (currentHead) currentHead.style.display = headHasHit ? '' : 'none';
              currentHead = el;
              headHasHit = false;
              return;
            }
            if (!el.hasAttribute('data-em-az-item')) return;
            var hit = !q || el.textContent.toLowerCase().indexOf(q) !== -1;
            el.style.display = hit ? '' : 'none';
            if (hit) { headHasHit = true; any = true; }
          });
          if (currentHead) currentHead.style.display = headHasHit ? '' : 'none';
          if (nomatch) nomatch.style.display = any ? 'none' : 'block';
          if (letters) letters.style.display = q ? 'none' : '';
        });
        filter.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            var items = az.querySelectorAll('[data-em-az-item]');
            for (var i = 0; i < items.length; i++) {
              if (items[i].style.display !== 'none') { window.location.href = items[i].href; break; }
            }
          }
        });
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
